import React from 'react';
import { inject, observer } from 'mobx-react';
import { WeaLocaleProvider } from 'ecCom';

import './css';
import E8Header from './E8Header';
import E8LeftMenu from './E8LeftMenu';

const getLabel = WeaLocaleProvider.getLabel;

@inject('portalThemeStore')
@observer
class E8Theme extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { portalThemeStore, location } = this.props;
    const { pathname, query } = location;
    portalThemeStore.getTopMenu(pathname, query);
  }

  render() {
    const { portalThemeStore } = this.props;
    const { searchParams, themeInfo = {}, translatepage } = portalThemeStore;
    const { hideHeader, hideAside } = searchParams;
    const { themeData = {} } = themeInfo;
    const { cssfile = 'left', maincolor } = themeData;

    let contenttop = '';
    if (hideHeader == 'true') {
      contenttop = translatepage == '1' ? '30px' : '0px';
    } else {
      contenttop = translatepage == '1' ? '85px' : '55px';
    }

    return (
      <div className={`e8theme-layout-container e8theme-color-${cssfile}`}>
        {translatepage == '1' ? (
          <div className="e8theme-translate">
            <div className="trans-tips">{getLabel(518684, '您已进入翻译模式，点击高亮显示的页面文字即可进行翻译')}</div>
            <div className="trans-exit" onClick={this.exitTranslatepage}>
              {getLabel(518685, '退出翻译模式')}
            </div>
          </div>
        ) : null}
        {hideHeader == 'true' ? null : (
          <div className="e8theme-layout-header" style={translatepage == '1' ? { top: '30px' } : { top: '0px' }}>
            <E8Header ecId={`${(this && this.props && this.props.ecId) || ''}_E8Header@421ipu`} />
          </div>
        )}
        <div className="e8theme-layout-content" style={{ top: contenttop }}>
          <div id="themeLayoutMask" className="e8theme-layout-mask" />
          {hideAside == 'true' ? null : (
            <div className="e8theme-layout-aside">
              <E8LeftMenu ecId={`${(this && this.props && this.props.ecId) || ''}_E8LeftMenu@elvh5g`} />
            </div>
          )}
          <div className="e8theme-layout-main" style={hideHeader == 'true' && hideAside == 'true' ? { padding: 0 } : { backgroundColor: maincolor }}>
            <div id="themeLayoutRoute" className="e8theme-layout-route">
              {this.props.children}
            </div>
            <div id="themeLayoutFrame" className="e8theme-layout-frame">
              <iframe id="mainFrame" name="mainFrame" src="about:blank" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  exitTranslatepage = () => {
    const { portalThemeStore } = this.props;
    portalThemeStore.setTranslatepage(0);
    // 左侧菜单高度更正
    let asdh = $('.e8aside-container').height() - $('.e8aside-container .e8left-lmt').height() - $('.e8aside-container .e8left-lmb').height() + 30;
    $('.e8aside-container #menuScrollWrapper').css({ height: asdh });
  };
}

export default E8Theme;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/index.js